import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { ReceiptFormTypes } from "models/formTypes";
import { ReceiptPersonFormProps } from "models/propTypes/receiptPropTypes";
import { FormEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const ReceiptPersonForm: ForwardRefRenderFunction<FormHandles, ReceiptPersonFormProps> = (props, ref) => {
  return (
    <GenericForm<ReceiptFormTypes.ReceiptPerson>
      formRef={ref}
      {...props}
      fields={{
        name: {
          label: TranslationKeys.Common.Name,
          type: FormEnums.FormFieldType.TEXT,
        },
        company: {
          label: TranslationKeys.Common.Company,
          type: FormEnums.FormFieldType.TEXT,
        },
      }}
    />
  );
};

export default forwardRef(ReceiptPersonForm);
